export class MlFrontendApiError extends Error {
  readonly status: number;
  readonly operation?: string;

  constructor(
    message: string,
    status: number,
    options?: { operation?: string },
  ) {
    super(message);
    this.name = "MlFrontendApiError";
    this.status = status;
    this.operation = options?.operation;
  }
}

export class MlFrontendFeatureDisabledError extends Error {
  constructor() {
    super("ML Frontend is not enabled");
    this.name = "MlFrontendFeatureDisabledError";
  }
}

export class MlFrontendUnauthorizedError extends Error {
  constructor() {
    super("You are not authorized to complete this request.");
    this.name = "MlFrontendUnauthorizedError";
  }
}
